/* Name:Chaitali Khachane
   Description:This is the pop-up page,this page will render once we click on onboard button on data Assets screen
   in this page we will allow user to fill details to onboard asset like asst name ,description,country ,region etc....
   on Click on submit button it will call submit API and clear all the form values
   or cancel button will discard all the filled value without saving it
               
*/

import React, { Fragment, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import Button from "../../component/button/button"
import FormDropdown from "../../component/dropdown/formDropdown"
import ErrorMessage from "../../component/errorMessage/errorMsg"
import FormInputDescription from "../../component/inputtext/formInputDescription"
import Forminputtext from "../../component/inputtext/forminputtext"
import PopUpScreen from "../../component/popUpScreen/popUpScreen"
import { emptyErrorCheck } from "../../helpers/validation/emptyValidation"
import { addNewDataAsset, getADLSFile, getHomedataAssets } from "../../redux/home/home.action"
import { CLEAR_ALL_ERROR_MESSAGE, RESET_NEWASSETS_FORM, SET_ERROR_MESSAGE, SET_FORM_OPTION, SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "../../redux/home/home.type"
import { emptycheckFields } from "../../validator/pageValidation"
import { FieldLabel } from "../global/global.style"
import { Button as PrimeButton } from 'primereact/button';
import { LabelWrapper } from "../../component/inputtext/inputtextStyle"
import { _alphaNumvalidateInput } from "../../helpers/validation/nameValidation"
import FileExplorerDirectory from "./fileExplorerDirectory"
import FileExplorerFile from "./fileExplorerFile"


function AddNewDataAssests({ showLoadingMessage, show, onHide, changeDetail }) {
    const { formData, apiData } = useSelector((state) => state.home)
    const dispatch = useDispatch()
    const [editableDataAssetOwner, setEditableDataAssetOwner] = useState(false)
    const [editableDataSteward, setEditableDataSteward] = useState(false)
    const [editableProductName, setEditableProductName] = useState(false)
    const [fileExplorerDirectoryEnable, setFileExplorerDirectoryEnable] = useState(false)
    const [fileExplorerFileEnable, setFileExplorerFileEnable] = useState(false)

    const duplicateCheck = (fieldType, value) => {
        switch (fieldType) {
            case "assestName": {
                setErrorMessage(fieldType, "")

                apiData.dataAssests.data.map((val) => {
                    if (val.data_asset_name.toLowerCase() === value.toLowerCase()) {
                        setErrorMessage(fieldType, "An asset with this name already exits. Please choose a different name")
                        return true
                    }
                })
                return false
                // dispatch()
            }
            default: console.log(fieldType + " fieldType is not present")
        }
    }

    //this method will call the redux and set the error message to the passed field
    const setErrorMessage = (fieldname, errorMessage) => {
        dispatch({
            type: SET_ERROR_MESSAGE,
            payload: {
                formField: fieldname,
                isError: true,
                errorMessage: errorMessage
            }
        })
    }
    const onFolderClick = (val) => {
        dispatch({
            type: SET_FORM_VALUE,
            payload: {
                formField: "adlsDirectoryForm",
                value: val.name
            }
        })
        dispatch({
            type: SET_FORM_VALUE,
            payload: {
                formField: "adlsFileName",
                value: ""
            }
        })
        dispatch({
            type: SET_FORM_VALUEOBJ,
            payload: {
                formField: "adlsFileName",
                valueAsObj: {}
            }
        })
        dispatch({
            type: SET_FORM_OPTION,
            payload: {
                formField: "adlsFileName",
                data: apiData.adlsDirectory.data.adls_files[val.name]
            }
        })
        setFileExplorerFileEnable(true)
    }
    const onFileClick = (val) => {
        dispatch({
            type: SET_FORM_VALUE,
            payload: {
                formField: "adlsFileName",
                value: val
            }
        })
    }
    useEffect(() => {
        dispatch(getHomedataAssets())
    }, [])
    return <PopUpScreen style={{ width: "90%" }} header="Onboard Asset" onHide={() => {
        dispatch({
            type: RESET_NEWASSETS_FORM
        })
        dispatch({
            type: CLEAR_ALL_ERROR_MESSAGE
        })
        onHide()
    }}
    >
        <div className="grid" >
            <div className="col-6" >
                <Forminputtext style={{ width: "100%", marginBottom: "8px", height: "40px" }} label="Asset Name" name="assestName" value={formData.assestName.value} required={true} onChange={(e) => {
                    if (e.target.value === "" || _alphaNumvalidateInput(e.target.value)) {
                        duplicateCheck("assestName", e.target.value);
                        changeDetail(e, "text");
                    } else {
                        e.preventDefault();
                    }

                }} />
                <ErrorMessage message={formData.assestName.errorMessage} />

                {editableDataAssetOwner ? (
                <Forminputtext 
                style={{ width: "calc(100% - 40px)", height: "40px", marginBottom: "5px" }} 
                label="Data Asset Owner" 
                name="dataAssetOwner" 
                value={formData.dataAssetOwner.value} 
                required={true} 
                onChange={(e) => changeDetail(e, "text")} 
                     />
            ) : (
                <FormDropdown 
                    required 
                    style={{ width: "calc(100% - 40px)", height: "40px", marginBottom: "5px" }} 
                    options={formData.dataAssetOwner.options} 
                    placeholder="Select..." 
                    label="Data Asset Owner" 
                    name="dataAssetOwner" 
                    value={formData.dataAssetOwner.valueAsObj} 
                    onChange={(e) => changeDetail(e, "dropdown", e.target.value)} 
                />
            )}
            {editableDataAssetOwner ? (
                <PrimeButton 
                    onClick={() => {
                        dispatch({ type: SET_FORM_VALUE, payload: { formField: "dataAssetOwner", value: "" } });
                        setEditableDataAssetOwner(false);
                    }} 
                    style={{ verticalAlign: "baseline" }} 
                    icon="pi pi-minus" 
                />
            ) : (
                <PrimeButton 
                    onClick={() => {
                        dispatch({ type: SET_FORM_VALUE, payload: { formField: "dataAssetOwner", value: "" } });
                        dispatch({ type: SET_FORM_VALUEOBJ, payload: { formField: "dataAssetOwner", valueAsObj: null } });
                        setEditableDataAssetOwner(true);
                    }} 
                    style={{ verticalAlign: "baseline" }} 
                    icon="pi pi-plus" 
                />
            )}
            <ErrorMessage message={formData.dataAssetOwner.errorMessage} />
            </div>

            <div className="col-6" >
                <FormInputDescription placeholder="Write Description..." style={{ width: "100%", height: "83%" }} label="Assets Description" name="assestDescription" value={formData.assestDescription.value} onChange={(e) => changeDetail(e, "text")} />
                <ErrorMessage message={formData.assestDescription.errorMessage} />

                {/* <Forminputtext style={{ width: "100%", height: "40px" }} label="Product Owner" name="productOwner" value={formData.productOwner.value} required={true} onChange={(e) => changeDetail(e, "text")} />
                <ErrorMessage message={formData.productOwner.errorMessage} /> */}
            </div>
        </div>
        <div className="grid">
            <div className="col-6">
                <FormDropdown style={{ width: "100%", height: "40px", marginBottom: "5px" }} required options={formData.region.options} placeholder='Select Cluster' optionLabel="region" label="Cluster" name="region" value={formData.region.valueAsObj} onChange={(e) => changeDetail(e, "dropdown", e.target.value.region)} />
                <ErrorMessage message={formData.region.errorMessage} />
            </div>
            <div className="col-6">
                <FormDropdown style={{ width: "100%", height: "40px", marginBottom: "5px" }} required disabled={Object.keys(formData.region.valueAsObj).length === 0} options={formData.region.valueAsObj.country} placeholder='Select Market' optionLabel="country" label="Market" name="country" value={formData.country.value} onChange={(e) => changeDetail(e, "dropdown", e.target.value)} />
                <ErrorMessage message={formData.country.errorMessage} />
            </div>
        </div>
        <div className="grid">
            <div className="col-6">
                {editableDataSteward ? <Forminputtext style={{ width: "calc(100% - 40px)", height: "40px", marginBottom: "5px" }} label="Data Steward" name="dataSteward" value={formData.dataSteward.value} required={true} onChange={(e) => {
                    changeDetail(e, "text")
                }} /> :
                    <FormDropdown required style={{ width: "calc(100% - 40px)", height: "40px", marginBottom: "5px" }} options={formData.dataSteward.options} placeholder='Select... ' label="Data Steward" name="dataSteward" value={formData.dataSteward.valueAsObj} onChange={(e) => { changeDetail(e, "dropdown", e.target.value) }} />}
                {editableDataSteward ? <PrimeButton onClick={() => {
                    dispatch({
                        type: SET_FORM_VALUE,
                        payload: {
                            formField: "dataSteward",
                            value: ""
                        }
                    })
                    setEditableDataSteward(false)
                }} style={{ verticalAlign: "baseline" }} icon="pi pi-minus" /> : <PrimeButton onClick={() => {
                    dispatch({
                        type: SET_FORM_VALUE,
                        payload: {
                            formField: "dataSteward",
                            value: ""
                        }
                    })
                    dispatch({
                        type: SET_FORM_VALUEOBJ,
                        payload: {
                            formField: "dataSteward",
                            valueAsObj: null
                        }
                    })
                    setEditableDataSteward(true)
                }} style={{ verticalAlign: "baseline" }} icon="pi pi-plus" />}
                <ErrorMessage message={formData.dataSteward.errorMessage} />

            </div>
            <div className="col-6">
                <FormDropdown style={{ marginBottom: "5px", width: "100%" }} options={formData.frequency.options} placeholder='Select Frequency ' optionLabel="name" label="Frequency" name="frequency" value={formData.frequency.valueAsObj} onChange={(e) => changeDetail(e, "dropdown", e.target.value.name)} />
                <ErrorMessage message={formData.frequency.errorMessage} />


            </div>
        </div>
        <div className="grid">
            <div className="col-6" >
                <FormDropdown style={{ width: "100%", marginBottom: "5px" }} options={formData.domainSubDomainForm.options} placeholder='Choose the Domain' optionLabel="domain_name" label="Domain" name="domain" value={formData.domain.valueAsObj} required={true} onChange={(e) => changeDetail(e, "dropdown", e.target.value.domain_name)} />
                <ErrorMessage message={formData.domain.errorMessage} />
                <FormDropdown style={{ width: "100%", marginBottom: "5px" }} disabled={Object.keys(formData.domain.valueAsObj).length === 0} options={formData.domain.valueAsObj.subdomains} placeholder='Choose the Sub Domain' optionLabel="sub_domain_name" label="Sub Domain" name="subDomain" value={formData.subDomain.valueAsObj} required={true} onChange={(e) => changeDetail(e, "dropdown", e.target.value.sub_domain_name)} />
                <ErrorMessage message={formData.subDomain.errorMessage} />

                {editableProductName ? <Forminputtext style={{ width: "calc(100% - 40px)", height: "40px", marginBottom: "5px" }} label={<span style={{ marginTop: "5px" }}>Analytical Product Name</span>} placeholder='Please enter Product Name' name="productName" value={formData.productName.value} onChange={(e) => {
                    changeDetail(e, "text")
                }} /> :
                    <FormDropdown style={{ width: "calc(100% - 40px)", marginBottom: "5px" }} options={formData.productName.options} placeholder='Please enter Product Name' optionLabel="data_prod_name" label={<span style={{ marginTop: "5px" }}>Analytical Product Name</span>} name="productName" value={formData.productName.valueAsObj} onChange={(e) => changeDetail(e, "dropdown", e.target.value.data_prod_name)} />
                }
                {editableProductName ? <PrimeButton onClick={() => {
                    dispatch({
                        type: SET_FORM_VALUE,
                        payload: {
                            formField: "productName",
                            value: ""
                        }
                    })
                    setEditableProductName(false)
                }} style={{ verticalAlign: "baseline" }} icon="pi pi-minus" /> : <PrimeButton onClick={() => {
                    dispatch({
                        type: SET_FORM_VALUE,
                        payload: {
                            formField: "productName",
                            value: ""
                        }
                    })
                    dispatch({
                        type: SET_FORM_VALUEOBJ,
                        payload: {
                            formField: "productName",
                            valueAsObj: null
                        }
                    })
                    setEditableProductName(true)
                }} style={{ verticalAlign: "baseline" }} icon="pi pi-plus" />}
                <ErrorMessage message={formData.productName.errorMessage} />
                {/* <FormDropdown style={{ width: "100%", marginBottom: "5px" }} options={formData.productName.options} placeholder='Please enter Product Name' optionLabel="data_prod_name" label={<span style={{ marginTop: "5px" }}>Analytical Product Name</span>} name="productName" value={formData.productName.valueAsObj} onChange={(e) => changeDetail(e, "dropdown", e.target.value.data_prod_name)} />
                <ErrorMessage message={formData.productName.errorMessage} /> */}
            </div>
            <div className="col-6" >
                <div className="grid">

                    <div className="col-3" style={{ paddingBottom: "0px" }}>
                        {/* <br /> */}
                        <FormDropdown
                            required={true}
                            style={{ width: '100%' }} label="Select File"
                            options={formData.filePickUp.options} optionLabel="name" name="filePickUp" value={formData.filePickUp.valueAsObj} onChange={(e) => changeDetail(e, "dropdown", e.target.value.name)}
                        />
                        <ErrorMessage message={formData.filePickUp.errorMessage} />
                    </div>
                    <div className="col-9" style={{ paddingBottom: "0px" }}>
                        {formData.filePickUp.valueAsObj.name === "Local" ? <Fragment>
                            {/* <LabelWrapper>
                                <FieldLabel>
                                </FieldLabel>
                            </LabelWrapper> */}
                            <input
                                type="file"
                                accept=".csv,.parquet"
                                id="file-input"
                                name="selectedFile"
                                style={{ display: 'none', marginTop: "25px" }}  // Hide the default file input
                                onChange={(e) => changeDetail(e, "file")}
                            />
                            <label
                                htmlFor="file-input"
                                className="custom-file-upload"
                                style={{ width: "100%", marginTop: "21px" }}
                            >
                                <i className="pi pi-plus" style={{ fontWeight: 'bold', fontSize: '10px', marginRight: '4px' }}></i>
                                {formData.selectedFile.value ? formData.selectedFile.value.name : 'Choose file'}
                            </label>
                            <ErrorMessage message={formData.selectedFile.errorMessage} />
                        </Fragment> : formData.filePickUp.valueAsObj.name === "ADLS" ? <Fragment>
                            <FormDropdown required style={{ marginRight: "5px", marginBottom: "5px", width: "Calc(100% - 50px)", height: "40px" }}
                                options={formData.adlsList.options}
                                placeholder='Select ADLS' label="ADLS Account" name="adlsList"
                                value={formData.adlsList.valueAsObj}

                                onChange={(e) => {
                                    dispatch(getADLSFile(e.target.value))
                                    dispatch({
                                        type: SET_FORM_VALUE,
                                        payload: {
                                            formField: "adlsDirectoryForm",
                                            value: ""
                                        }
                                    })
                                    dispatch({
                                        type: SET_FORM_VALUEOBJ,
                                        payload: {
                                            formField: "adlsDirectoryForm",
                                            valueAsObj: {}
                                        }
                                    })
                                    dispatch({
                                        type: SET_FORM_VALUE,
                                        payload: {
                                            formField: "adlsFileName",
                                            value: ""
                                        }
                                    })
                                    dispatch({
                                        type: SET_FORM_VALUEOBJ,
                                        payload: {
                                            formField: "adlsFileName",
                                            valueAsObj: {}
                                        }
                                    })
                                    changeDetail(e, "dropdown", e.target.value)
                                }
                                } /><PrimeButton onClick={() => setFileExplorerDirectoryEnable(true)} style={{ width: "40px", height: "40px", verticalAlign: "baseline" }} icon="pi pi-search" aria-label="Search" />
                            <ErrorMessage message={formData.adlsList.errorMessage} />

                            {/* <FormDropdown required style={{ marginBottom: "5px", width: "100%", height: "40px" }} options={formData.adlsDirectoryForm.options} placeholder='Select Directory ' optionLabel="name" label="Select Directory" name="adlsDirectoryForm" value={formData.adlsDirectoryForm.valueAsObj} onChange={(e) => {
                                changeDetail(e, "dropdown", e.target.value.name)
                                dispatch({
                                    type: SET_FORM_VALUE,
                                    payload: {
                                        formField: "adlsFileName",
                                        value: ""
                                    }
                                })
                                dispatch({
                                    type: SET_FORM_VALUEOBJ,
                                    payload: {
                                        formField: "adlsFileName",
                                        valueAsObj: {}
                                    }
                                })
                                dispatch({
                                    type: SET_FORM_OPTION,
                                    payload: {
                                        formField: "adlsFileName",
                                        data: apiData.adlsDirectory.data.adls_files[e.target.value.name]
                                    }
                                })
                            }} />
                            <ErrorMessage message={formData.adlsDirectoryForm.errorMessage} /> */}

                            {/* <FormDropdown required style={{ marginBottom: "5px", width: "100%", height: "40px" }} options={formData.adlsFileName.options} placeholder='Select File ' label="Select File" name="adlsFileName" value={formData.adlsFileName.value} onChange={(e) => changeDetail(e, "dropdown", e.target.value)} />
                            <ErrorMessage message={formData.adlsFileName.errorMessage} /> */}
                            <div style={{marginLeft:"5px",marginTop:"5px"}}>Selected File : {formData.adlsFileName.value}</div>
                        </Fragment> : ""}

                    </div>
                </div>

            </div>
        </div>
       
        <div className="grid">
            <div className="col-6">
                <div style={{
                    // display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    height: '70%',
                }}>
                    <div style={{ fontWeight: "bold", fontSize: "12pt", color: 'red' }}>Note : </div>
                    <li style={{ fontSize: "9pt" }}>
                        Supported File formats: csv, parquet, delta
                    </li>
                    <li style={{ fontSize: "9pt", }}>
                        Maximum file size allowed 10MB
                    </li>
                    {/* <li style={{ fontSize: "9pt" }}>
                        The Asset Name should be in “product_distribution” format and unique
                    </li>
                    <li style={{ fontSize: "9pt" }}>
                        Example : If you have ’dsp’ sample file from amazon product then the asset name will go amazon_dsp all lower case
                    </li> */}
                </div>
            </div>
            <div className="col-6" style={{ textAlign: "right" }} >
                <PrimeButton style={{ width: "100px", textAlign: "center", marginRight: "10px" }} outlined label="Cancel" onClick={() => {
                    dispatch({
                        type: RESET_NEWASSETS_FORM
                    })
                    dispatch({
                        type: CLEAR_ALL_ERROR_MESSAGE
                    })
                    onHide()
                }} />

                <Button style={{ textAlign: "center" }} iconEnable={false} value="Onboard" onClick={() => {
                    dispatch({
                        type: CLEAR_ALL_ERROR_MESSAGE
                    })
                    if (emptyErrorCheck(emptycheckFields.newAsset, formData, setErrorMessage).length > 0 || duplicateCheck("assetName", formData.assestName.value)) {
                    } else {
                        dispatch({
                            type: CLEAR_ALL_ERROR_MESSAGE
                        })
                        dispatch(addNewDataAsset(show, showLoadingMessage))
                        dispatch({
                            type: RESET_NEWASSETS_FORM
                        })
                        onHide()
                    }
                }} />
            </div>
        </div>
        {fileExplorerDirectoryEnable ? <FileExplorerDirectory onFolderClick={onFolderClick} closeDialog={() => {
            setFileExplorerDirectoryEnable(false)
           
        }
        } directoryLabelKey="name" directory={formData.adlsDirectoryForm.options} loading={apiData.adlsDirectory.loading} /> : ""}
        {fileExplorerFileEnable ? <FileExplorerFile 
        backClick={() => {
            setFileExplorerFileEnable(false)
            dispatch({
                type: SET_FORM_VALUE,
                payload: {
                    formField: "adlsDirectoryForm",
                    value: ""
                }
            })
            dispatch({
                type: SET_FORM_VALUE,
                payload: {
                    formField: "adlsFileName",
                    value: ""
                }
            })
            setFileExplorerDirectoryEnable(true)
        }
        } onFileClick={onFileClick} 
        closeDialog={() => {
            setFileExplorerFileEnable(false)
        }
        } 
        label={formData.adlsDirectoryForm.value}
        file={formData.adlsFileName.options} loading={false} /> : ""}

    </PopUpScreen>
}
export default AddNewDataAssests